import { SagaIterator } from 'redux-saga';
import { call, put, select, take, takeEvery } from 'redux-saga/effects';
import {
  GlobalActions,
  GlobalPut,
  NavigationRoute,
  ProvideVorvertragStatusValidationPayload,
} from '@ps20-frontend/shop-integration-redux';
import { App, AppSubroute } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { IAppState } from '../appState';
import { RsVermieterActions } from '../rs-vermietung-actions.service';

export function* handleRsVermietungNavigationToAngebotSaga(): SagaIterator {
  yield takeEvery(
    RsVermieterActions.HANDLE_RS_VERMIETUNG_NAVIGATION_TO_ANGEBOT,
    safeSaga(handleRsVermietungNavigationToAngebot, App.RS_VERMIETUNG),
  );
}

export function* handleRsVermietungNavigationToAngebot(): SagaIterator {
  const globalPut = GlobalPut.getInstance();
  const globalActions = new GlobalActions();
  const state: IAppState = yield select();

  yield call(
    globalPut.put,
    globalActions.requestVorvertragStatusValidation({
      appId: App.RS_VERMIETUNG,
      angebotsId: state.angebotsId,
      selectedVorvertragsNummern: state.vertragsoptionen?.vorvertragsNummern || [],
    }),
  );
  const contractValidationAction = yield take(
    GlobalActions.PROVIDE_VORVERTRAG_STATUS_VALIDATION,
  );
  const {
    validationResult: contractValidationResult,
    appId: contractAppId,
    angebotsId: contractAngebotsId,
  }: ProvideVorvertragStatusValidationPayload = contractValidationAction.payload;

  if (
    !(
      contractAppId === App.RS_VERMIETUNG &&
      contractAngebotsId === state.angebotsId &&
      contractValidationResult == null
    )
  ) {
    return;
  }

  yield put(new RsVermieterActions().quoteDBRequested());
  yield put(new RsVermieterActions().preisRequested());
  yield put(new RsVermieterActions().zumAngebotButtonClicked());
  const navRoute: NavigationRoute = {
    appId: App.RS_VERMIETUNG,
    subroute: AppSubroute.TAA_ANGEBOT,
  };
  return yield call(globalPut.put, globalActions.navigationRequested(navRoute));
}
